module.exports = __webpack_public_path__ + "static/media/align-right.a1f49227.svg";